import React from 'react';
import { Sparkle } from '@phosphor-icons/react';

/**
 * Sprint C — DriversSection
 * "What may be driving how you feel" — careful narrative lines from
 * /api/health/state.drivers. Never diagnoses. Hidden when empty.
 */
export const DriversSection = ({ drivers }) => {
  if (!drivers || drivers.length === 0) return null;

  return (
    <section
      data-testid="health-drivers"
      aria-labelledby="health-drivers-heading"
      className="bg-[#F4EFE3]/60 border border-[#E5DFD0] rounded-2xl p-5"
    >
      <div className="flex items-center gap-2 mb-3">
        <Sparkle size={14} weight="duotone" className="text-[#235347]" aria-hidden />
        <h3
          id="health-drivers-heading"
          className="text-[10px] font-semibold uppercase tracking-[0.22em] text-[#235347]"
        >
          What may be driving how you feel
        </h3>
      </div>
      <ul className="space-y-2.5">
        {drivers.slice(0, 3).map((line, i) => (
          <li
            key={i}
            data-testid={`health-driver-${i}`}
            className="text-[13.5px] text-[#1F2D3F] leading-relaxed pl-3 border-l-2 border-[#235347]/30"
          >
            {line}
          </li>
        ))}
      </ul>
      <p className="text-[10.5px] italic text-slate-400 mt-4 leading-relaxed">
        Patterns Kindra has noticed — never diagnosis, always worth flagging if persistent.
      </p>
    </section>
  );
};

export default DriversSection;
